// ** React Imports
import React, { useState, useEffect, useCallback } from 'react'

import Divider from '@mui/material/Divider'
import Icon from '../../../@core/components/icon'

import Box from '@mui/material/Box'
import { DataGrid } from '@mui/x-data-grid'
import CustomChip from '../table/Chip'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Popover from '@mui/material/Popover';

import CustomAvatar from '../../../@core/components/mui/avatar'
import CustomTextField from '../../../@core/components/mui/text-field'
import { copyToClipboard } from '../../../component/functions/clipboardUtils'
import { grey } from '@mui/material/colors'
import Spinner from '../../../@core/components/spinner'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  }
}

export const fileBoxes = [
  { id: "Order", label: "O" },
  { id: "Return", label: "R" },
  { id: "intransit", label: "I" },
  { id: "spf Claims", label: "C" },
  { id: "Payment", label: "P" },
]

const Pending = props => {
  const { loading } = props

  const [value, setValue] = useState('')
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 })
  const [viewData, setViewData] = useState([])
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const [openFileView, setOpenFileView] = useState(null)
  const [personName, setPersonName] = useState([])
  const [errorList, setErrorList] = useState([])
  const [newError, setNewError] = useState('')

  const openPopover = Boolean(anchorEl);

  const defaultErrorList = [
    { title: 'The Shawshank Redemption' },
    { title: 'The Godfather' },
    { title: 'The Godfather: Part II' },
    { title: 'The Dark Knight' },
    { title: '12 Angry Men' },
    { title: "Schindler's List" },
    { title: 'Pulp Fiction' },
    { title: 'The Lord of the Rings: The Return of the King' }
  ]

  useEffect(() => {
    setErrorList(defaultErrorList)
  }, [])


  const handleClickOpen = useCallback((error) => {
    setValue(error)
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const handleSubmit = () => {
    if (newError) {
      setErrorList([...errorList, { title: newError }])
      setNewError('')
      setOpen(false)
    }
  }

  const handleClick = useCallback((event, data) => {
    setOpenFileView(data)
    setAnchorEl(event.currentTarget);
  }, [])

  const tableData = [
    { id: "1", status: "success", fullName: 'Galen Slixby', email: 'gslixby0@abc.net.au', role: 'editor', billing: 'Auto Debit', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error1', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'spf Claims'] },
    { id: "2", status: "warning", fullName: 'Halsey Redmore', email: 'hredmore1@imgur.com', role: 'author', billing: 'Manual - Paypal', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error2', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'spf Claims'] },
    { id: "3", status: "success", fullName: 'Marjory Sicely', email: 'msicely2@who.int', role: 'maintainer', billing: 'Manual - Cash', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error3', balance: '100', pendingFile: ['Payment', 'Order', 'Payment', 'spf Claims'] },
    { id: "4", status: "success", fullName: 'Cyrill Risby', email: 'crisby3@wordpress.com', role: 'maintainer', billing: 'Auto Debit', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error4', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "5", status: "warning", fullName: 'Maggy Hurran', email: 'mhurran4@yahoo.co.jp', role: 'subscriber', billing: 'Auto Debit', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error5', balance: '100', pendingFile: ['Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "6", status: "error", fullName: 'Silvain Halstead', email: 'shalstead5@shinystat.com', role: 'author', billing: 'Manual - Cash', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error6', balance: '100', pendingFile: ['Payment', 'intransit', 'Payment', 'spf Claims'] },
    { id: "7", status: "warning", fullName: 'Breena Gallemore', email: 'bgallemore6@boston.com', role: 'subscriber', billing: 'Manual - Paypal', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error7', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "8", status: "warning", fullName: 'Kathryne Liger', email: 'kliger7@vinaora.com', role: 'author', billing: 'Auto Debit', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error8', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "9", status: "success", fullName: 'Franz Scotfurth', email: 'fscotfurth8@dailymotion.com', role: 'subscriber', billing: 'Manual - Credit Card', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error9', balance: '100', pendingFile: ['intransit', 'Payment', 'spf Claims'] },
    { id: "10", status: "success", fullName: 'Jillene Bellany', email: 'jbellany9@kickstarter.com', role: 'maintainer', billing: 'Manual - Credit Card', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error10', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "11", status: "success", fullName: 'Jonah Wharlton', email: 'jwharltona@oakley.com', role: 'subscriber', billing: 'Auto Debit', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "12", status: "success", fullName: 'Seth Hallam', email: 'shallamb@hugedomains.com', role: 'subscriber', billing: 'Auto Debit', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "13", status: "error", fullName: 'Yoko Pottie', email: 'ypottiec@privacy.gov.au', role: 'subscriber', billing: 'Manual - Cash', currentPlan: 'basic', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "14", status: "error", fullName: 'Maximilianus Krause', email: 'mkraused@stanford.edu', role: 'author', billing: 'Manual - Paypal', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "15", status: "error", fullName: 'Zsazsa McCleverty', email: 'zmcclevertye@soundcloud.com', role: 'maintainer', billing: 'Manual - Credit Card', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "16", status: "error", fullName: 'Bentlee Emblin', email: 'bemblinf@wired.com', role: 'author', billing: 'Auto Debit', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "17", status: "error", fullName: 'Brockie Myles', email: 'bmylesg@amazon.com', role: 'maintainer', billing: 'Manual - Paypal', currentPlan: 'basic', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
  ];

  useEffect(() => {
    setViewData(tableData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = [
    {
      flex: 0.20,
      minWidth: 250,
      field: 'fullName',
      headerName: 'Trueseller Id',
      renderCell: ({ row }) => {
        const { fullName, email } = row

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CustomAvatar
              skin='light'
              color={row.avatarColor}
              sx={{ mr: 2.5, width: 38, height: 38, fontWeight: 500, fontSize: theme => theme.typography.body1.fontSize }}
            >
              {row.fullName.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), '')}
            </CustomAvatar>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
              <Typography
                noWrap
                sx={{
                  fontWeight: 500,
                  textDecoration: 'none',
                  color: 'text.secondary',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                {fullName}
                <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(`${fullName}`, 'Platform Id')} />
              </Typography>
              <Typography noWrap variant='body2' sx={{ color: 'text.disabled' }}>
                {email}
                <Icon icon="iconamoon:copy-duotone" width="12" height="12" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(`${email}`, 'trueseller Id')} />
              </Typography>
            </Box>
          </Box>
        )
      }
    },
    {
      flex: 0.12,
      minWidth: 120,
      field: 'Plan',
      headerName: 'Company Name',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'capitalize' }}>
            {row.currentPlan}
            <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(row.currentPlan, 'Company Name')} />
          </Typography>
        )
      }
    },
    {
      flex: 0.13,
      minWidth: 150,
      field: 'billing',
      headerName: 'Supplier ID',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary' }}>
            {row.billing}
            <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(row.billing, 'Supplier ID')} />
          </Typography>
        )
      }
    },
    {
      flex: 0.15,
      minWidth: 150,
      field: 'status',
      headerName: 'Pending File',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary', display: "flex" }} aria-owns={openPopover ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
          >
            {fileBoxes
              .filter((box) => row.pendingFile.includes(box.id)) // Filter relevant fileBoxes
              .map((box) => {
                return (
                  <CustomChip
                    key={box.id} // Unique key to prevent unnecessary re-renders
                    rounded
                    label={box.label}
                    style={{ margin: '0 2px' }}
                    skin="light"
                    color="error"
                    onClick={(e) => handleClick(e, box.id)}
                    sx={{
                      "&:hover, &.Mui-focusVisible": {
                        backgroundColor: "#ea545529",
                        color: "#EA5455",
                      },
                    }}
                  />
                )
              }
              )
            }

            {/* <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(row.status, 'Pending File')} /> */}
          </Typography >
        )
      }
    },

    {
      flex: 0.1,
      minWidth: 110,
      field: 'last_updated',
      headerName: 'Last Updated',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary' }}>
            {row.last_updated}
          </Typography>
        )
      }
    },

    {
      flex: 0.1,
      minWidth: 110,
      field: 'error',
      headerName: 'Error Details',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary' }} onClick={() => handleClickOpen(row.error)}>
            {row.error}
          </Typography>
        )
      }
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'balance',
      headerName: 'Current Credit Balance',
      renderCell: ({ row }) => {
        return (
          <CustomChip
            rounded
            skin='light'
            size='small'
            label={row.balance}
            color={row.status}
            sx={{ textTransform: 'capitalize' }}
          />
        )
      }
    }
  ]

  if (loading) {
    return <div style={{ width: "100%", paddingTop: "50px" }}>
      <Spinner height={"100%"} />
    </div>
  }
  const renderContent = () => {
    return <Box style={{ width: '100%' }}>
      <Divider sx={{ m: '0 !important' }} />

      <DataGrid
        autoHeight
        rowHeight={55}
        rows={viewData}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth='sm' aria-labelledby='max-width-dialog-title'>
        <DialogTitle id='form-dialog-title'>Error Details</DialogTitle>
        <DialogContent>
          <CustomTextField
            fullWidth
            rows={1}
            multiline
            label='Existing'
            defaultValue='Default Value'
            id='textarea-outlined-static'
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
          <CustomTextField
            select
            fullWidth
            label='Select Error'
            id='select-multiple-default'
            sx={{ mt: 3 }}
            SelectProps={{ MenuProps, value: personName, onChange: e => setPersonName(e.target.value) }}
          >
            {errorList.map(name => (
              <MenuItem key={name.title} value={name.title}>
                {name.title}
              </MenuItem>
            ))}
          </CustomTextField>
          <CustomTextField
            fullWidth
            rows={4}
            multiline
            sx={{ mt: 3 }}
            placeholder='Add New'
            id='textarea-outlined-static'
            value={newError}
            onChange={(e) => setNewError(e.target.value)}
          />

        </DialogContent>
        <DialogActions className='dialog-actions-dense'>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>

      <Popover
        id="mouse-over-popover"
        open={openPopover}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setOpenFileView(null);
        }}
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ display: 'flex', py: 1, px: 2, backgroundColor: grey[50], gap: 1 }}>
          {openFileView}
        </Box>
      </Popover>

      {/* <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
      >
        Hover with a Popover.
      </Typography> */}
      {/* <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={openPopover}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>I use Popover.</Typography>
      </Popover> */}
    </Box>
  }

  return renderContent()
}

export default Pending

